import { useDispatch, useSelector } from 'react-redux';
import { orgActions } from '../store/orgSettings';
import { getPermissionModule, hasPermissionByKey } from './subscriptionPermissionHelpers';

export { canShowCrmNav, getPermissionModule, hasPermissionByKey } from './subscriptionPermissionHelpers';

export const useSubscriptionPermission = (permissionKey) => {
  const { permissions } = useSelector((s) => s.orgSettings);
  const dispatch = useDispatch();

  const permissionModule = getPermissionModule(permissionKey, permissions);
  const hasPermission = hasPermissionByKey(permissionKey, permissions);

  const getPermissions = () => dispatch(orgActions.getPermissions({}));

  return {
    hasPermission,
    getPermissions,
    permissionModule,
    permissions,
  };
};
